/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Natural_PersonInputs */

const cs_enum_natural_person = /** @type {(inputs: Enum_Natural_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fyzická osoba`)
};

const en_enum_natural_person = /** @type {(inputs: Enum_Natural_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natural person`)
};

/**
* | output |
* | --- |
* | "Natural person" |
*
* @param {Enum_Natural_PersonInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_natural_person = /** @type {((inputs?: Enum_Natural_PersonInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Natural_PersonInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_natural_person(inputs)
	return cs_enum_natural_person(inputs)
});